<template>
  <v-card
    v-if="drug && dose"
    class="white vetalfa-view"
    :max-width="_getMaxWidth()"
  >
    <div v-if="!isDrugsManagement" class="vetalfa-header" ref="screenHeader">
      <vetalfa-small-header
        :isDrugsManagement="isDrugsManagement"
        :backMethod="managementBackMethod"
        :title="category ? category.portugueseName : null"
        hasShareOption
      ></vetalfa-small-header>
      <vetalfa-drugs-header
        v-if="drug"
        :name="drug.name"
        displayInteractions
        :description="drug.description"
      ></vetalfa-drugs-header>
    </div>
    <div ref="screenContent">
      <vetalfa-dose-card :prop="dose"></vetalfa-dose-card>
      <vetalfa-section-item-title
        v-for="(obj1, index) in dose.sections"
        :key="index + obj1.description"
        :prop="obj1.description"
      >
        <vetalfa-simple-table v-if="obj1.table" :table="obj1.table">
        </vetalfa-simple-table>
        <vetalfa-section-item
          v-for="(obj2, index) in obj1.objects"
          :key="index + obj2.description"
          :prop="obj2.description"
          :index="index"
        >
          <vetalfa-simple-table v-if="obj2.table" :table="obj2.table">
          </vetalfa-simple-table>
          <vetalfa-section-sub-item
            v-for="(obj3, index) in obj2.objects"
            :key="index + obj3.description"
            :prop="obj3.description"
            :index="index"
          >
            <vetalfa-simple-table v-if="obj3.table" :table="obj3.table">
            </vetalfa-simple-table
          ></vetalfa-section-sub-item>
        </vetalfa-section-item>
      </vetalfa-section-item-title>
      <vetalfa-section-title
        v-if="dose.references && dose.references.length"
        :prop="references_label"
      >
        <div v-for="reference in dose.references" :key="reference.name">
          <vetalfa-reference-card
            :reference="reference"
          ></vetalfa-reference-card>
        </div>
      </vetalfa-section-title>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { mdiArrowLeft } from "@mdi/js";
import labels from "@/constants/labels.js";
export default {
  name: "Doses",
  methods: {
    ...mapActions("drugs", ["openCategoryItem", "setDose"]),
    ...mapMutations("drugs", ["setDose"]),
    managementBackMethod() {
      this.setDose(null);
    },
    setupDoses() {
      if (!this.isDrugsManagement) {
        this.openCategoryItem({
          id: this.$route.params.id,
          category: this.$route.params.category,
          redirect: false,
        }).then(() => {
          this.setDose(this.drug.doses[this.$route.params.dose]);
          this._setupScreenSizes(this);
        });
      }
    },
  },
  computed: {
    ...mapGetters("drugs", ["drug", "dose", "product", "category"]),
  },
  watch: {
    dose(val) {
      if (!val) {
        this.setupDoses();
      }
    },
  },
  props: {
    isDrugsManagement: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: {
        mdiArrowLeft,
      },
      references_label: labels.REFERENCES,
      headerHeight: 0,
    };
  },
  mounted() {
    this.setupDoses();
  },
};
</script>